module.exports = __webpack_public_path__ + "static/img/howplayBack.befa379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howplayBack.jpg
// module id = RH4N
// module chunks = 2